// import { getBaseUrl } from '../main';
export const appConfig = {
  apiUrl: document.getElementsByTagName('base')[0].href // '' //getBaseUrl()
};
